import React, {useState, useEffect, PureComponent} from 'react';
import {useParams} from 'react-router-dom';
import {Row, Col, Button,} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import ReactExport from 'react-data-export';
import Widget from '../../components/Widget';
import s from './SalesDetail.module.scss';
import {Table, TableContainer, TableHead, TableBody, TableRow, TableCell} from "@mui/material";
import PubSub from "pubsub-js";
import {SeccionalBanco} from "../../pages/seccionales/objects/SeccionalBanco";
import {CountrySectionalComparativeModel} from "../CountrySectional/model/CountrySectionalComparativeModel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export class SalesDetail extends PureComponent {
    state = {
        data: [],
        dataGlobal: [],
        maxYear: this.props.maxYear,
        mes: this.props.mes,
        sectional: this.props.sectional
    }

    //  DataSet = [
    //     {
    //         columns: [
    //             {title: "NIT", style: {font: {sz: "13", bold: true}}, width: {wpx: 125}}, // width in pixels
    //             {title: "FECHA RADICACIÓN", style: {font: {sz: "13", bold: true}}, width: {wch: 30}}, // width in characters
    //             {title: "MES", style: {font: {sz: "13", bold: true}}, width: {wpx: 100}}, // width in pixels
    //             {title: "AÑO", style: {font: {sz: "13", bold: true}}, width: {wpx: 125}}, // width in pixels
    //             {title: "NOMBRE COMERCIO", style: {font: {sz: "13", bold: true}}, width: {wpx: 100}}, // width in pixels
    //             {title: "BANCO", style: {font: {sz: "13", bold: true}}, width: {wpx: 125}}, // width in pixels
    //             {title: "DIRECCIÓN", style: {font: {sz: "13", bold: true}}, width: {wch: 30}}, // width in characters
    //             {title: "TELÉFONO", style: {font: {sz: "13", bold: true}}, width: {wpx: 125}}, // width in pixels
    //             {title: "TELÉFONO 2", style: {font: {sz: "13", bold: true}}, width: {wpx: 125}}, // width in pixels
    //             {title: "ASESOR", style: {font: {sz: "13", bold: true}}, width: {wpx: 110}}, // width in pixels
    //             {title: "TEAM LEADER", style: {font: {sz: "13", bold: true}}, width: {wpx: 110}}, // width in pixels
    //             {title: "CÓDIGO ÚNICO", style: {font: {sz: "13", bold: true}}, width: {wpx: 110}}, // width in pixels
    //             {title: "NUEVO O REFERIDO", style: {font: {sz: "13", bold: true}}, width: {wpx: 110}}, // width in pixels
    //             {title: "ESTADO", style: {font: {sz: "13", bold: true}}, width: {wpx: 110}}, // width in pixels
    //             {title: "PAGO", style: {font: {sz: "13", bold: true}}, width: {wpx: 110}}, // width in pixels
    //             {title: "SECCIONAL", style: {font: {sz: "13", bold: true}}, width: {wpx: 110}}, // width in pixels
    //         ],
    //         this.state.dataGlobal: data.map((item) => [
    //             {value: item.nit, style: {font: {sz: "10"}}},
    //             {value: item.fecha_radicado, style: {font: {sz: "10"}}},
    //             {value: item.mes, style: {font: {sz: "10"}}},
    //             {value: item.anio, style: {font: {sz: "10"}}},
    //             {value: item.nombre_comercio, style: {font: {sz: "10"}}},
    //             {value: item.banco, style: {font: {sz: "10"}}},
    //             {value: item.direccion, style: {font: {sz: "10"}}},
    //             {value: item.telefono1, style: {font: {sz: "10"}}},
    //             {value: item.telefono2, style: {font: {sz: "10"}}},
    //             {value: item.ejecutivo, style: {font: {sz: "10"}}},
    //             {value: item.lider, style: {font: {sz: "10"}}},
    //             {value: item.codigo, style: {font: {sz: "10"}}},
    //             {value: item.nueva, style: {font: {sz: "10"}}},
    //             {value: item.estado, style: {font: {sz: "10"}}},
    //             {value: item.pago, style: {font: {sz: "10"}}},
    //             {value: item.seccional, style: {font: {sz: "10"}}},
    //         ])
    //     }
    // ]
    // useEffect(() => {
    //     this.url = "/salesDetail/anio/"+this.props.maxYear+"/seccional/"+this.props.sectional+"/mes/"+this.props.mes
    //     console.log(this.url)
    //     fetch(url)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             setData(data)
    //             console.log(data);
    //         });
    // }, []);
    componentDidMount() {
        // PubSub.subscribe('reloadmaxYear', this.onmaxyaer.bind(this));
        // PubSub.subscribe('reloadmes', this.onmes.bind(this));
        // PubSub.subscribe('reloadsectional', this.onsectional.bind(this));
        this.props.onLoading(true);
        this.getInfoSales(this.state.maxYear, this.props.mes, this.props.sectional);
    }
    getInfoSales(anio,mes,sectional) {

        if(anio!= null){
            this.API_URL =  "/salesDetail/anio/"+anio+"/seccional/"+sectional+"/mes/"+mes
        }

        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {

                this.setState(() => ({
                    data: data1
                }), ()=>{

                })
            });

    }
    render() {
        return (
            <div>

                {/*<ExcelFile*/}
                {/*    filename="Detalle ventas"*/}
                {/*    element={<button type="primary" style={{marginBottom: "15px"}}*/}
                {/*                     className="btn btn-success float-right m-3">Descargar</button>}>*/}
                {/*    <ExcelSheet dataSet={DataSet} name="Detalle ventas"/>*/}
                {/*</ExcelFile>*/}
                <br/>
                <br/>
                <br/>
                <Widget>
                    <Row>
                        <Col lg="12" xs="10">
                            <div>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow key={-1}>
                                                <TableCell>NIT</TableCell>
                                                <TableCell>FECHA RADICACIÓN</TableCell>
                                                <TableCell>MES</TableCell>
                                                <TableCell>AÑO</TableCell>
                                                <TableCell>NOMBRE COMERCIO</TableCell>
                                                <TableCell>BANCO</TableCell>
                                                <TableCell>DIRECCIÓN</TableCell>
                                                <TableCell>TELÉFONO</TableCell>
                                                <TableCell>TELÉFONO 2</TableCell>
                                                <TableCell>ASESOR</TableCell>
                                                <TableCell>TEAM LEADER</TableCell>
                                                <TableCell>CÓDIGO ÚNICO</TableCell>
                                                <TableCell>NUEVO O REFERIDO</TableCell>
                                                <TableCell>ESTADO</TableCell>
                                                <TableCell>PAGO</TableCell>
                                                <TableCell>SECCIONAL</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                this.state.data.map(item =>
                                                    (<TableRow key={item.idinfo_general}>
                                                        <TableCell>{item.nit}</TableCell>
                                                        <TableCell>{item.fecha_radicado}</TableCell>
                                                        <TableCell>{item.mes}</TableCell>
                                                        <TableCell>{item.anio}</TableCell>
                                                        <TableCell>{item.nombre_comercio}</TableCell>
                                                        <TableCell>{item.banco}</TableCell>
                                                        <TableCell>{item.direccion}</TableCell>
                                                        <TableCell>{item.telefono1}</TableCell>
                                                        <TableCell>{item.telefono2}</TableCell>
                                                        <TableCell>{item.ejecutivo}</TableCell>
                                                        <TableCell>{item.lider}</TableCell>
                                                        <TableCell>{item.codigo}</TableCell>
                                                        <TableCell>{item.nueva}</TableCell>
                                                        <TableCell>{item.estado}</TableCell>
                                                        <TableCell>{item.pago}</TableCell>
                                                        <TableCell>{item.seccional}</TableCell>
                                                    </TableRow>))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Col>
                    </Row>

                </Widget>
            </div>
        );

    }
}

